// extracted by mini-css-extract-plugin
module.exports = {"link":"arrow-button-module--link--h9Kdl","label":"arrow-button-module--label--3C2xe","arrow":"arrow-button-module--arrow--3HPKr"};